// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__35nqq","modalForm":"UpgradeEpcsModal_modalForm__2Ng7K","modalFooter":"UpgradeEpcsModal_modalFooter__1pBSC"};